import React from 'react';
import EducatorFiltersDialog from './EducatorFiltersDialog';
import useQuery from '@/pages/educators/useQuery';

export default function EducatorsFilterDialog(props) {
  return <EducatorFiltersDialog {...props} useQuery={useQuery} />;
}
